function getChipColor(accentColor, disabled) {
  if (disabled) {
    return "default";
  } else if (!accentColor) {
    return "tertiary";
  } else if (accentColor === "primary") {
    return "info";
  } else {
    return "secondary";
  }
}
function getIconColor(accentColor, disabled) {
  if (disabled || !accentColor) {
    return "action";
  } else {
    return accentColor;
  }
}
export {
  getChipColor,
  getIconColor
};
//# sourceMappingURL=product-card.functions.es.js.map
